import { DependencyList, useEffect, useState } from 'react';

import { useTransitionApi } from './useTransitionApi';

export const useTransitionMemo = <T>(
  factory: () => T,
  deps: DependencyList | undefined
): T => {
  const [value, setValue] = useState<T>(factory());
  const { updateDOM } = useTransitionApi({
    // disable flushSync as the updateDOM is called inside useEffect on reaction
    // to data change
    flushSync: false,
  });
  useEffect(() => {
    updateDOM(() => {
      setValue(factory());
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return value;
};
